import { useState } from 'react';

type ModalType = 'photo' | 'createReview' | 'uploadMenu';

export const useModal = () => {
  const [modalState, setModalState] = useState<Record<ModalType, boolean>>({
    photo: false,
    createReview: false,
    uploadMenu: false,
  });

  const openModal = (modalType: ModalType) => {
    setModalState(prev => ({ ...prev, [modalType]: true }));
  };

  const closeModal = (modalType: ModalType) => {
    setModalState(prev => ({ ...prev, [modalType]: false }));
  };

  return { modalState, openModal, closeModal };
};